<div tooltip data-popover="{{tooltip}}" [popover]="tooltip" triggers="hover" containerClass="custom-popover">
    <app-icon glyph name="info-{{color}}"></app-icon>
</div>
